// removed by extract-text-webpack-plugin
module.exports = {"faqContainer":"faqContainer__3aV-5","innerFaqContainer":"innerFaqContainer__1hOKD","faqHeader":"faqHeader__3XimP","innerSection":"innerSection__1_O6r","faqsContainer":"faqsContainer__JiaBI","eachFaqContainer":"eachFaqContainer__1eXeX","faqQuestion":"faqQuestion__1e_1w","faqAnswer":"faqAnswer__Cy820","expandedSymbol":"expandedSymbol__363yA","collapedSymbol":"collapedSymbol__3zQ4C","eachFaqContaine":"eachFaqContaine__IlSkr"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVC/faq/style.css
// module id = ApQB
// module chunks = 380